import { calculationLimits, signalDurations } from "store/calculation.config";

export const calculateSignal = (input) => {
    const errors = {
        TOOLS_SPEEDLIMIT_TOO_LOW: false,
        TOOLS_SPEEDLIMIT_TOO_HIGH: false,
        TOOLS_REGULATED_LENGTH_TOO_LOW: false,
        TOOLS_HOURLY_TRAFFIC_IS_EQUAL_ZERO: false,
        TOOLS_SIGNAL_REGULATION_NOT_RECOMENDED: false,
        TOOLS_CYCLE_TIME_AND_GREEN_TIME_CORRECTED: false,
    }

    let calculationContext = {
        normalizedInput: {...input},
        wasNormalized: false,
        errorsToSet: [],
        errorsToUnset: [],
        input:
        {
            speedlimit: {value: null, valid: null, severity: null},
            regulatedLength: {value: null, valid: null, severity: null},
            trafficForward: {value: null, valid: null, severity: null},
            trafficBackward: {value: null, valid: null, severity: null},
        },
        derived:
        {
            trafficTotal: {value: null, valid: null, severity: null},
            trafficDisproportion: {value: null, valid: null, severity: null},
        },
        output:
        {
            emptyingTime: {value: null, valid: null, severity: null},
            greenTimeForward: {value: null, valid: null, severity: null},
            greenTimeBackward: {value: null, valid: null, severity: null},
            signalDurationValues: {value: null, valid: null, severity: null},
            greenTime: {value: null, valid: null, severity: null},
            correctedCycleTime: {value: null, valid: null, severity: null},
            signalDesignForward: {value: null, valid: null, severity: null},
            signalDesignBackward: {value: null, valid: null, severity: null},
        }
    }

    validateValues(calculationContext, errors);
    calculateDerived(calculationContext, errors);
    calulcateOutput(calculationContext, errors);

    calculationContext.errorsToSet = Object.keys(errors).filter(key => errors[key]);
    calculationContext.errorsToUnset = Object.keys(errors).filter(key => !errors[key]);

    return calculationContext;
}

const validateValues = (ctx, errors) => {
    // #region speedlimit
    if(ctx.normalizedInput.speedlimit.trim() !== '')
    {
        const speedlimit = Number(ctx.normalizedInput.speedlimit.trim());
        if(speedlimit < calculationLimits.minSpeed)
        {
            ctx.input.speedlimit = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_SPEEDLIMIT_TOO_LOW = true;
        }
        else if(speedlimit > calculationLimits.maxSpeed)
        {
            ctx.input.speedlimit = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_SPEEDLIMIT_TOO_HIGH = true;
        }
        else
        {
            ctx.input.speedlimit = {value: speedlimit, valid: true, severity: null};
        }
    }
    // #endregion

    // #region regulated length
    if(ctx.normalizedInput.regulatedLength.trim() !== '')
    {
        const regulatedLength = Number(ctx.normalizedInput.regulatedLength.trim());
        if(regulatedLength <= 0)
        {
            ctx.input.regulatedLength = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_REGULATED_LENGTH_TOO_LOW = true;
        }
        else
        {
            ctx.input.regulatedLength = {value: regulatedLength, valid: true, severity: null};
        }
    }
    // #endregion

    // #region traffic forward
    if(ctx.normalizedInput.trafficForward.trim() !== '')
    {
        const trafficForward = Number(ctx.normalizedInput.trafficForward.trim());
        if(trafficForward <= 0)
        {
            ctx.input.trafficForward = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_HOURLY_TRAFFIC_IS_EQUAL_ZERO = true;
        }
        else
        {
            ctx.input.trafficForward = {value: trafficForward, valid: true, severity: null};
        }
    }
    // #endregion

    // #region traffic backward
    if(ctx.normalizedInput.trafficBackward.trim() !== '')
    {
        const trafficBackward = Number(ctx.normalizedInput.trafficBackward.trim());
        if(trafficBackward <= 0)
        {
            ctx.input.trafficBackward = {value: null, valid: false, severity: 'error'};
            errors.TOOLS_HOURLY_TRAFFIC_IS_EQUAL_ZERO = true;
        }
        else
        {
            ctx.input.trafficBackward = {value: trafficBackward, valid: true, severity: null};
        }
    }
    // #endregion
}

const calculateDerived = (ctx, errors) => {
    if(ctx.input.trafficBackward.valid && ctx.input.trafficForward.valid)
    {
        ctx.derived.trafficTotal = {
            value: ctx.input.trafficForward.value + ctx.input.trafficBackward.value,
            valid: true,
            severity: null
        }

        ctx.derived.trafficDisproportion = {
            value: ctx.input.trafficBackward.value/ctx.derived.trafficTotal.value,
            valid: true,
            severity: null
        }
    }
}

const calulcateOutput = (ctx, errors) => {
    if(ctx.input.speedlimit.valid && ctx.input.regulatedLength.valid)
    {
        let emptyingTime = 3.6 * ctx.input.regulatedLength.value / ctx.input.speedlimit.value;
        if(emptyingTime <= 6) emptyingTime = 6;
        else
        {
            emptyingTime = Math.ceil(emptyingTime/10) * 10;
        }

        ctx.output.emptyingTime = {
            value: emptyingTime,
            valid: true,
            severity: null
        }
    }

    if(ctx.derived.trafficTotal.valid && ctx.output.emptyingTime.valid && ctx.derived.trafficDisproportion.valid)
    {   
        const signalDurationValues = {
            cycleTime: null,
            greenTime: null
        }

        const signalDurationsObject = signalDurations.find(el => el.traffic >= ctx.derived.trafficTotal.value);
        if(signalDurationsObject)
        {
            const signalDurationObject2 = signalDurationsObject.values.find(el => el.emptyingTime >= ctx.output.emptyingTime.value);
            if(signalDurationObject2)
            {
                signalDurationValues.cycleTime = signalDurationObject2.cycleTime;
                signalDurationValues.greenTime = signalDurationObject2.greenTime;
            }
        }
        
        if(!signalDurationValues.cycleTime || !signalDurationValues.greenTime)
        {
            errors.TOOLS_SIGNAL_REGULATION_NOT_RECOMENDED = true;
        }
        else
        {
            ctx.output.correctedCycleTime = {
                value: signalDurationValues.cycleTime,
                valid: true,
                severity: null
            }

            let greenTimeForward = 2 * signalDurationValues.greenTime * (1 - ctx.derived.trafficDisproportion.value);

            if(greenTimeForward < 6)
            {
                const diff = 6 - greenTimeForward;
                ctx.output.correctedCycleTime.value += diff;
                ctx.output.correctedCycleTime.severity = 'warning';

                ctx.output.greenTimeForward = {
                    value: 6,
                    valid: true,
                    severity: 'warning'
                }

                errors.TOOLS_CYCLE_TIME_AND_GREEN_TIME_CORRECTED = true;
            }
            else
            {
                ctx.output.greenTimeForward = {
                    value: greenTimeForward,
                    valid: true,
                    severity: null
                }
            }

            let greenTimeBackward = 2 * signalDurationValues.greenTime * ctx.derived.trafficDisproportion.value;

            if(greenTimeBackward < 6)
            {
                const diff = 6 - greenTimeBackward;
                ctx.output.correctedCycleTime.value += diff;
                ctx.output.correctedCycleTime.severity = 'warning';

                ctx.output.greenTimeBackward = {
                    value: 6,
                    valid: true,
                    severity: 'warning'
                }

                errors.TOOLS_CYCLE_TIME_AND_GREEN_TIME_CORRECTED = true;
            }
            else
            {
                ctx.output.greenTimeBackward = {
                    value: greenTimeBackward,
                    valid: true,
                    severity: null
                }
            } 
        }
    }

    if(ctx.output.greenTimeForward.valid && ctx.output.greenTimeBackward.valid && ctx.output.correctedCycleTime.valid && ctx.output.emptyingTime.valid)
    {
        ctx.output.signalDesignForward = {
            value: [
                {
                    type: 'green',
                    duration: ctx.output.greenTimeForward.value,
                    percentage: ctx.output.greenTimeForward.value/ctx.output.correctedCycleTime.value
                },
                {
                    type: 'yellow', 
                    duration: 3.0,
                    percentage: 3.0/ctx.output.correctedCycleTime.value
                },
                {
                    type:'emptying',
                    duration: ctx.output.emptyingTime.value,
                    percentage: ctx.output.emptyingTime.value/ctx.output.correctedCycleTime.value
                },
                {
                    type: 'red',
                    duration: ctx.output.greenTimeBackward.value + 3.0,
                    percentage: (ctx.output.greenTimeBackward.value + 3.0)/ctx.output.correctedCycleTime.value
                },
                {
                    type: 'emptying',
                    duration: ctx.output.emptyingTime.value,
                    percentage: ctx.output.emptyingTime.value/ctx.output.correctedCycleTime.value
                },
            ],
            valid: true,
            severity: null
        }

        ctx.output.signalDesignBackward = {
            value: [
                {
                    type: 'red',
                    duration: ctx.output.greenTimeForward.value + 3.0,
                    percentage: (ctx.output.greenTimeForward.value + 3.0)/ctx.output.correctedCycleTime.value
                },
                {
                    type:'emptying',
                    duration: ctx.output.emptyingTime.value,
                    percentage: ctx.output.emptyingTime.value/ctx.output.correctedCycleTime.value
                },
                {
                    type: 'green',
                    duration: ctx.output.greenTimeBackward.value,
                    percentage: ctx.output.greenTimeBackward.value/ctx.output.correctedCycleTime.value
                },
                {
                    type: 'yellow', 
                    duration: 3.0,
                    percentage: 3.0/ctx.output.correctedCycleTime.value
                },
                {
                    type:'emptying',
                    duration: ctx.output.emptyingTime.value,
                    percentage: ctx.output.emptyingTime.value/ctx.output.correctedCycleTime.value
                },
            ],
            valid: true,
            severity: null
        }
    }
}